<template>
  <div class="table no-treeview table-bg search">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>결제 리스트</h2>
      </div>
      <div v-if="loading === false" class="strong-text center">
        <span class="title">총 결제:&nbsp;&nbsp;</span><span :class="pagination.total > 0 ? 'plus' : (pagination.total < 0 ? 'minus': 'zero')">{{ Number(pagination.total).toLocaleString() }}</span>건
        <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;총 금액:&nbsp;&nbsp;</span><span :class="sum.paymentTotal > 0 ? 'plus' : (sum.paymentTotal < 0 ? 'minus': 'zero')">{{ sum.paymentTotal ? Number(sum.paymentTotal).toLocaleString() : 0 }}</span>원
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div v-if="searchType === 'nonpayment'" class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div>
      </div>
    </div>
    <div class="table-desc search">
      <table>
        <tr class="header">
          <th>거래 날짜</th>
          <th>승인 날짜</th>
          <th>승인 결과</th>
          <th v-if="searchType === 'nonpayment'">손실 금액</th>
          <th v-else>승인/거절 금액</th>
          <!-- <th>거절 사유</th> -->
          <th>거래 형태</th>
          <th>결제 수단</th>
          <th>설치 주소</th>
          <th>설치 장소</th>
          <th>결제 상품</th>
          <th>사업자명</th>
          <th>운영자명</th>
          <th v-if="searchType === 'nonpayment'">사유</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in payList" :key="item.ID" @click="goDetail(item)">
            <td>
              <div>{{ item.paymentDate }}</div>
              <div class="time">{{ item.paymentTime }}</div>
            </td>
            <td>
              <div>{{ item.approveDate }}</div>
              <div class="time">{{ item.approveTime }}</div>
            </td>
            <td>
              <div>{{ item.approveResult }}</div>
            </td>
            <td>
              <div v-if="searchType === 'nonpayment'">{{ item.paymentPriceWon }}</div>
              <div v-else>{{ item.approvePriceWon }}</div>
            </td>
            <!-- <td>
              <div>{{ item.rejectCode }}</div>
            </td> -->
            <td>
              <div>{{ item.approveType }}</div>
            </td>
            <td>
              <div>{{ item.paymentMode }}</div>
            </td>
            <td>
              <div>{{ item.address }}</div>
            </td>
            <td>
              <div>{{ item.place }}</div>
            </td>
            <td>
              <div>{{ item.paymentDetail }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.operatorUID }}</div>
            </td>
            <td v-if="searchType === 'nonpayment'">
              <div>{{ item.resultMsg }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="12">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel

export default {
  props: ['searchCondition', 'searchEvent', 'startTime', 'endTime', 'searchType'],
  data: () => ({
    payList: [],
    sum: null,
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
  }),
  created() {
    /*
    this.getSum();
    this.getList(false);
    */
  },
  watch: {
    searchEvent: {
      handler() {
        this.pagination.page = 1;
        this.pagination.input = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;

        this.getSum();
        this.loadPagination();
        this.getList(false);
      },
    },
  },
  methods: {
    refreshList() {
      this.getSum();
      this.getList(false);
    },
    savePagination() {
      const page = {
        claim: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page.claim !== undefined) this.pagination.page = page.claim;
    },
    async getSum() {
      this.sum = 0;

      try {
        let url = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/sum`;
        if (this.searchType === 'nonpayment') {
          // TODO url += '?approveResult=2&state=1&state=2&state=12&state=131';
          url += '?approveResult=2&state=13&state=12&state=131';
        } else {
          url += '?approveResult=1&state=1&state=7&state=101';
        }
        if (this.searchCondition) {
          url += `&${this.searchCondition}`;
        }
        const res = await this.$http.get(url, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.sum = {
          paymentTotal: res.data.paymentSum.paymentTotal,
          paymentCount: res.data.paymentSum.paymentCount,
        };
      } catch (e) {
        this.sum = null;
        alert('정보를 가져오는데 실패하였습니다.\n잠시후 다시 시도해주세요.');

        console.error(e);
      }
    },
    async getCount() {
      try {
        let countURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/count`;
        if (this.searchType === 'nonpayment') {
          // TODO countURL += '?approveResult=2&state=1&state=2&state=12&state=131';
          countURL += '?approveResult=2&state=13&state=12&state=131';
        } else {
          countURL += '?approveResult=1&state=1&state=7&state=101&state=105&state=112&state=115';
        }
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return this.pagination.total;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return this.pagination.total;
    },
    async getList(forDownload) {
      this.savePagination();
      this.loading = true;
      const payList = [];
      if (!forDownload) {
        this.payList = [];
        this.pagination.input = this.pagination.page;
        await this.getCount();
      }

      try {
        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;

        let listURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }&showAll=true`;
        if (this.searchType === 'nonpayment') {
          // TODO listURL += '&approveResult=2&state=1&state=2&state=12&state=131';
          listURL += '&approveResult=2&state=13&state=12&state=131';
        } else {
          listURL += '&approveResult=1&state=1&state=7&state=101&state=105&state=112&state=115';
        }
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return payList;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        for (let i = 0; i < resList.data.payments.length; i++) {
          const p = resList.data.payments[i];
          const approveResult = this.$getConstName(
            'approveResult',
            p.approveResult,
          );
          const approveType = this.$getConstName('approveType', p.approveType);
          const paymentMode = this.$getConstName('paymentMode', p.paymentMode);
          const aDate = p.approveAt ? this.$moment(p.approveAt).format('YYYY.MM.DD') : '-';
          // const aTime = p.approveAt ? this.$moment(p.approveAt).format('hh:mm A') : '-';
          const aTime = p.approveAt ? this.$moment(p.approveAt).format('HH:mm:ss') : '-';
          let paymentDetail = null;
          if (p.paymentDetails) {
            let productCount = 0;
            for (let j = 0; j < p.paymentDetails.length; j++) {
              const pd = p.paymentDetails[j];
              productCount += pd.productCount;
            }
            if (productCount === 1) {
              // paymentDetail = `${p.paymentDetails[0].productName.substr(0, 4)}`;
              paymentDetail = `${p.paymentDetails[0].productName}`;
            } else if (productCount > 1) {
              // paymentDetail = `${p.paymentDetails[0].productName.substr(0, 2)} 외 ${productCount - 1} 개`;
              paymentDetail = `${p.paymentDetails[0].productName} 외 ${productCount - 1} 개`;
            }
          }

          const payment = {
            num,
            ID: p.paymentID,
            paymentDate: this.$moment(p.paymentAt).format('YYYY.MM.DD'),
            // paymentTime: this.$moment(p.paymentAt).format('hh:mm A'),
            paymentTime: this.$moment(p.paymentAt).format('HH:mm:ss'),
            approveDate: aDate,
            approveTime: aTime,
            paymentDetail: paymentDetail || '-',
            approveResult: approveResult || '처리전',
            paymentPrice: p.paymentPrice,
            paymentPriceWon: `${p.paymentPrice.toLocaleString()}원`,
            approvePrice: p.approvePrice,
            approvePriceWon: p.approveResult ? `${p.approvePrice.toLocaleString()}원` : '-',
            resultCode: p.resultCode ? p.resultCode : '-',
            approveType: approveType || '-',
            paymentMode: paymentMode || '-',
            address: p.address ? p.address : '-',
            place: p.place ? p.place : '-',
            divisionID: p.divisionID ? p.divisionID : '-',
            deviceID: p.deviceID ? p.deviceID : '-',
            companyID: p.companyID,
            companyName: p.companyName ? p.companyName : '-',
            operatorUID: p.OperatorUID ? p.OperatorUID : '-',
            resultMsg: p.resultMsg ? p.resultMsg : '-',
          };
          payList.push(payment);

          num--;
        }

        if (!forDownload) {
          this.payList = payList;
        }
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.payList = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return payList;
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getSum();
      this.getList(false);
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getSum();
      this.getList(false);
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getSum();
      this.getList(false);
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getSum();
      this.getList(false);
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getSum();
      this.getList(false);
    },
    goDetail(value) {
      this.$emit('selectPay', value.ID);
    },
    async downloadExcel() {
      try {
        const perPage = this.pagination.perPage;
        const page = this.pagination.page;
        const input = this.pagination.input;
        const total = this.pagination.total;
        const length = this.pagination.length;

        const companyList = {};
        const claims = [];
        this.pagination.perPage = 500;
        for (this.pagination.page = 1; this.pagination.page < 500; this.pagination.page++) {
          const list = await this.getList(true);
          if (list.length === 0) {
            break;
          }
          for (let j = 0; j < list.length; j++) {
            const it = list[j];

            //
            let registrationNo = '';
            if (!companyList[it.companyID]) {
              const company = await this.$getCompany(it.companyID, false, false);
              if (company) {
                companyList[it.companyID] = company;
                registrationNo = company.registrationNo;
              }
            } else {
              registrationNo = companyList[it.companyID].registrationNo;
            }

            const p = {
              사업자번호: registrationNo,
              회사이름: it.companyName,
              거래날짜: `${it.paymentDate} ${it.paymentTime}`,
              승인날짜: `${it.approveDate} ${it.approveTime}`,
              /*
              paymentDate: it.paymentDate,
              paymentTime: it.paymentTime,
              approveDate: it.approveDate,
              approveTime: it.approveTime,
              */
              거절사유: it.resultMsg,
              paymentID: it.ID,
              paymentDetail: it.paymentDetail,
              approveResult: it.approveResult,
              paymentPrice: it.paymentPrice,
              approvePrice: it.approvePrice,
              approveType: it.approveType,
              paymentMode: it.paymentMode,
              address: it.address,
              place: it.place,
              divisionID: it.divisionID,
              deviceID: it.deviceID,
              companyID: it.companyID,
              operatorUID: it.OperatorUID,
              resultCode: it.resultCode,
            };
            claims.push(p);
          }
        }
        if (claims.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          return;
        }
        this.pagination.perPage = perPage;
        this.pagination.page = page;
        this.pagination.input = input;
        this.pagination.total = total;
        this.pagination.length = length;

        js2excel.json2excel({
          data: claims,
          name: 'cella-nonpayment',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/claim/ClaimList.vue